import styles from './PollAnswer.module.css';

export default function PollAnswer({ icon, text, onClick }) {
    return (
        <button className={styles.PollAnswer} onClick={onClick}>
            <div className={styles.PollAnswerIcon}>{icon}</div>
            <div className={styles.PollAnswerText}>{text}</div>
        </button>
    );
}
